import { type ContextMenuItemGroup, type ContextMenuItem } from '@teamworksdev/vuetify';

/**
 * Type narrowing function to check if an item is a ContextMenuItemGroup
 * Warning: Due to the nature of the type definitions, these types have places where they can overlap, so this function may not be 100% accurate. But for the most part it is functionally correct.
 * @param item - The item to check
 * @returns true if the item is a ContextMenuItemGroup
 */
export function isContextMenuItemGroup(item: ContextMenuItemGroup | ContextMenuItem): item is ContextMenuItemGroup {
  // ContextMenuItemGroup has required 'items' array
  // ContextMenuItem has optional 'items' array
  // The presence of 'items' as an array indicates it's a ContextMenuItemGroup
  return 'items' in item && Array.isArray(item.items);
}

/**
 * Type narrowing function to check if an item is a ContextMenuItem
 * Warning: Due to the nature of the type definitions, these types have places where they can overlap, so this function may not be 100% accurate. But for the most part it is functionally correct.
 * @param item - The item to check
 * @returns true if the item is a ContextMenuItem
 */
export function isContextMenuItem(item: ContextMenuItemGroup | ContextMenuItem): item is ContextMenuItem {
  return !isContextMenuItemGroup(item);
}

/**
 * Type narrowing function to check if an array contains ContextMenuItemGroups
 * @param items - The array to check
 * @returns true if the array contains ContextMenuItemGroups
 */
export function isContextMenuItemGroups(items: ContextMenuItemGroup[] | ContextMenuItem[]): items is ContextMenuItemGroup[] {
  return items.length === 0 || items.every(isContextMenuItemGroup);
}

/**
 * Type narrowing function to check if an array contains ContextMenuItems
 * @param items - The array to check
 * @returns true if the array contains ContextMenuItems
 */
export function isContextMenuItems(items: ContextMenuItemGroup[] | ContextMenuItem[]): items is ContextMenuItem[] {
  return items.length === 0 || items.every(isContextMenuItem);
}
